import script from "./LayoutWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./LayoutWidget.vue?vue&type=script&setup=true&lang=js"

import "./LayoutWidget.vue?vue&type=style&index=0&id=2499a6ca&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2499a6ca"]])

export default __exports__